<template>
	<a class="twitter-timeline" data-height="500" href="https://twitter.com/forestryclimate?ref_src=twsrc%5Etfw">Tweets by the FCCP</a>
</template>

<script>
export default {
	name: 'TwitterFeed',
	mounted() {
		let feed = document.createElement("script");
		feed.setAttribute("src", "https://platform.twitter.com/widgets.js")
		document.head.appendChild(feed)
	}
};
</script>

<style>

</style>